export class ApiError extends Error {
  constructor(
    public code: string,
    message: string,
  ) {
    super(message);
  }
}
const authMessages: Record<string, string> = {
  INVALID_CODE:
    "O código não foi aceito. Confira o autenticador e tente novamente.",
  INVALID_BACKUP_CODE:
    "O código de recuperação é inválido ou já foi usado. Confira outro código guardado.",
  INVALID_EMAIL_OR_PASSWORD: "Confira seu e-mail e senha.",
  TOO_MANY_ATTEMPTS_REQUEST_NEW_CODE:
    "O limite de tentativas foi atingido. Entre novamente para continuar.",
  TOO_MANY_REQUESTS: "Aguarde um pouco antes de tentar novamente.",
};
export async function api<T>(
  path: string,
  body?: unknown,
  method = body === undefined ? "GET" : "POST",
  idempotencyKey?: string,
): Promise<T> {
  const response = await fetch(path, {
    method,
    credentials: "same-origin",
    headers:
      body === undefined
        ? {}
        : {
            "Content-Type": "application/json",
            "Idempotency-Key": idempotencyKey ?? crypto.randomUUID(),
          },
    ...(body === undefined ? {} : { body: JSON.stringify(body) }),
  });
  const result = await response.json();
  if (!response.ok)
    throw new ApiError(
      result.error?.code ?? result.code ?? "request_failed",
      authMessages[result.code ?? result.error?.code] ??
        (response.status === 429
          ? "Aguarde um pouco antes de tentar novamente."
          : undefined) ??
        result.error?.message ??
        result.message ??
        "Não foi possível concluir. Tente novamente.",
    );
  return result as T;
}
